import React, { useRef } from "react";
import styled from "styled-components";
import { Text } from "../../atoms";
import { screen } from "../../../theme";

const CustomRadio = styled.label`
  display: flex;
  height: 300px;
  border-radius: 16px;
  border: 1px solid #b0b0b0;
  height: fit-content;
  padding: 16px 16px 24px 16px;
  gap: 10px;
  align-items: flex-start;
  width: 100%;
  cursor: pointer;

  input[type="radio"] {
    display: block;
    margin-top: 5px;
  }

  @media only screen and (${screen.md}) {
    min-height: ${({ height }) => height};
  }
`;

export const CustomRadioInput = ({
  value,
  onChange,
  name,
  description,
  height = "140px",
  checked,
}) => {
  const ref = useRef(null);

  return (
    <CustomRadio height={height}>
      <input
        checked={checked}
        type="radio"
        value={value}
        ref={ref}
        onChange={onChange}
        name={name}
      />
      <div>
        <Text type="h5" className="mb-2">
          {value}
        </Text>
        <Text type="p">{description}</Text>
      </div>
    </CustomRadio>
  );
};
